import {
  mapActions,
  mapGetters,
  mapState
} from 'vuex'
import {
  FETCH_POST
} from '@/store/actions.type'
import {
  arrayutility
} from '@/helper'
import localStorage from '@/api/localStorage'
import recentmention from '@/components/recentmention'
import ThePlaceHolder from '@/components/ThePlaceHolder'
import PDFUploader from '@/components/PDFUploader.vue'
import PDFViewer from '@/components/PDFViewer.vue'
import { SITE_URL } from '@/api/config'

export default {
  props: ['pId'],
  name: 'post',
  components: {
    recentmention,
    ThePlaceHolder,
    PDFUploader,
    PDFViewer
  },
  data() {
    return {
      seen: false,
      show: true,
      src: '',
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      rotate: 0,
      pdfWidth: '99%',
      postid: '',
      loading: false,
      resenttags: '',
      url: '',
      video: '',
      postid: '',
      post_content: '',
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
      vimeoUrl: '',
      videoiframe: '',
      contentStyle: ''
    }
  },

  methods: {
    ...mapState( {
      currenttab: ( state ) => state.rvtabs.activetabid,
      posts: ( state ) => state.post.data
    } ),
    ...mapGetters( ['activetabid', 'rvsinglepost'] ),
    ...mapActions( {
      fetchcurentPost: FETCH_POST
    } ),
    error: function ( err ) {
      // console.log(err)
    },
    password: function ( updatePassword, reason ) {
      updatePassword( prompt( 'password is "test"' ) )
    },

    updateWidth: function () {
      var that = this
      setTimeout( function () {
        that.pdfWidth = '100%'
      }, 1000 )
    },

    checkpostidexistinlocalstorage: function ( postId ) {
      var postidvalues = []
      postidvalues = JSON.parse( localStorage.getlocalStorage( 'postIDS' ) )
      if ( !postidvalues ) {
        postidvalues = []
      }
      var stateIndex = ''
      var indexExist = postidvalues.map( function ( postidvalues ) {
        //  console.log(postidvalues,"postidvalues");
        if ( postidvalues == postId ) {
          return false
        }
      } )
      return indexExist.indexOf( false ) > -1
    },
    async fetchPost( postId ) {
      var currentPostObject = {}
      // var postId = this.currenttab()
      // console.log(postId)
      this.loading = true
      if ( this.$store.state.appsetting.theme === 'd' ) {
        this.contentStyle = {
          color: 'white'
        }
      }
      var mk = await this.fetchcurentPost( postId )
      var currentPostObject = arrayutility.returnSingleObject( this.$store.state.post.data, 'postid', postId.split( '_' )[0] )

      // console.log("currentPostObject", currentPostObject, postId)
      this.postid = postId
      if ( currentPostObject.pdfsrc ) {
        this.url = currentPostObject.pdfsrc
      }
      if ( currentPostObject.post_content ) {
        this.post_content = currentPostObject.post_content
        /* Setting width and height for video */
        var updatedContent = this.post_content.replace( 'width="640"', 'width="100%"' )
        var height = $( window ).height()
        height = height - ( height * 25 / 100 )
        var updateheight = updatedContent.replace( 'height="360"', 'height="' + height + '"' )
        this.post_content = updateheight
      }
      // if (this.url) {
      //     this.seen = true
      // }
      // console.log('currentPostObject,', currentPostObject, postId)

      if ( currentPostObject.videosrc != undefined ) {
        if ( postId.split( '_' )[1] == 'alerts' ) {
          let checkpostidexistinlocalstorage = this.checkpostidexistinlocalstorage( postId )
          if ( checkpostidexistinlocalstorage ) {
            this.seen = true
          } else {
            this.seen = false
          }
        } else {
          this.seen = true
        }
        // console.log(currentPostObject,"currentPostObject")
        this.videoiframe = this.videoURL( currentPostObject.videosrc, false )
        var video1 = window.atob( currentPostObject.videosrc )
        this.video = video1.replace( /\"|\//g, '' )
        var windowSizeheightsearch = $( window ).height()
        var windowSizeheightexsearch = windowSizeheightsearch
        // $('.dashboardContantPdf').css('min-height', windowSizeheightexsearch + 'px')
        $( '.pdf-viewer__main,.dashboardContantPdf' ).css( 'min-height', windowSizeheightexsearch + 'px' )
      }
      this.documentError = undefined
      this.resenttags = Object.assign( {}, currentPostObject.symbol )

      this.loading = false
    },
    pdfHeight() {
      var windowSizeheightsearch = $( window ).height()
      $( '.pdf-viewer__main' ).css( 'min-height', windowSizeheightsearch + 'px' )
    },

    onDocumentErrored( e ) {
      this.documentError = e.text
    },

    videoURL: function ( src, emptyurl ) {
      var dec = window.atob( src )
      var outputsrc = JSON.parse( dec )
      if ( typeof ( outputsrc ) === 'object' ) {
        outputsrc = outputsrc[0]
      }
      // console.log(src,'src',typeof (outputsrc),"outputsrc",outputsrc);
      var video = ''
      var typesvideo = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?(?=.*v=((\w|-){11}))(?:\S+)?$/
      if ( outputsrc.match( typesvideo ) ) {
        var videoUrl = outputsrc.replace( /^.*?(\?|&)(v=([^&]+)).*$/i, '$3' )
        var urlv = 'https://www.youtube.com/embed/' + videoUrl
        var video =
                    '<iframe class="youTubeVideo" width="100%" height="450" src="' +
                    urlv +
                    '"></iframe>'
      } else {
        var videoID = outputsrc.split( 'vimeo.com/' )

        this.vimeoUrl =
                    SITE_URL +
                    'research-analyst-morning-call?id=' +
                    videoID[1]
        var video =
                    '<iframe class="youTubeVideo" width="100%" height="450" src="' +
                    this.vimeoUrl +
                    '" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" data-ready="true"></iframe>'
      }
      return this.vimeoUrl

      // console.log(video)
    }
  },
  beforeUpdate() {
    this.pdfHeight()
  },
  created: function () {
    let pid = this.pId
    this.fetchPost( this.pId )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/post.js